import React, { useState, useEffect } from "react";
import { HiMenuAlt4, HiX } from "react-icons/hi";
import { motion } from "framer-motion";

import { images } from "../../constants";
import "./Navbar.scss";
import { client } from "../../client";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const [curriculum, setCurriculum] = useState(null);

  useEffect(() => {
    const query = '*[_type == "curriculum"][0]'; // Obtenha apenas o primeiro documento de curriculum

    client.fetch(query).then((data) => {
      setCurriculum(data);
    });
  }, []);

  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <img src={images.thiagoLOogo} alt="logo" />
      </div>
      <ul className="app__navbar-links">
        {[
          "home",
          "about",
          "work",
          "skills",
          // "course",
          "testimonial",
          "contact",
        ].map((item) => (
          <li className="app__flex p-text" key={`link-${item}`}>
            <div />
            <a href={`#${item}`}>
              {item === "home"
                ? "Ínicio"
                : item === "about"
                ? "quem sou"
                : item === "work"
                ? "Projetos"
                : item === "skills"
                ? "Experiências"
                : // : item === "course"
                // ? "Cursos"
                item === "testimonial"
                ? "depoimentos"
                : "contato"}
            </a>
          </li>
        ))}
      </ul>
      <div className="app__navbar-currculo-parent">
        <a
          className="curriculo"
          target="_blank"
          href={curriculum?.curriculumFile}
        >
          Currículo
        </a>
      </div>
      <div className="app__navbar-menu">
        <HiMenuAlt4 onClick={() => setToggle(true)} />
        {toggle && (
          <motion.div
            whileInView={{ x: [300, 0] }}
            transition={{ duration: 0.85, ease: "easeOut" }}
          >
            <HiX onClick={() => setToggle(false)} />
            <ul>
              {[
                "Ínicio",
                "Quem sou",
                "Experiências",
                "Habilidades",
                "Cursos",
                "Contato",
              ].map((item) => (
                <li key={item}>
                  <a href={`#${item}`} onClick={() => setToggle(false)}>
                    {item}
                  </a>
                </li>
              ))}
              <button className="app__navbar-currculo-parent">
                <a
                  className="curriculo"
                  target="_blank"
                  href={curriculum?.curriculumFile}
                >
                  Currículo
                </a>
              </button>
            </ul>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
